module.exports = __webpack_public_path__ + "img/g2crowd.c75d6915.svg";